import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  TextInput,
  // SearchInput,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, CSR_FIELDS } from '../../providers/localization/constant'

const CSRListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${CSR_FIELDS}.title`)}
    // />,
    <TextInput key={0} source='title' label={translate(`${CSR_FIELDS}.title`)} />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.highlight.label`}
      source='is_highlight'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.highlight.choices.true` },
        { id: 'false', name: `${COMMON_FIELDS}.highlight.choices.false` },
      ]}
    />,
    // <SelectInput
    //   key={2}
    //   label={`${COMMON_FIELDS}.approved.label`}
    //   source='is_approved'
    //   choices={[
    //     { id: 'true', name: `${COMMON_FIELDS}.approved.choices.true` },
    //     { id: 'false', name: `${COMMON_FIELDS}.approved.choices.false` },
    //   ]}
    // />,
    <SelectInput
      key={3}
      label={`${COMMON_FIELDS}.published.label`}
      source='is_published'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
        { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
      ]}
    />,
    <SelectInput
      key={4}
      label={`${COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]
}

const CSRList = (): JSX.Element => {
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={CSRListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='show'>
        <TextField source='title_th' label={`${CSR_FIELDS}.title_th`}></TextField>
        <TextField source='title_en' label={`${CSR_FIELDS}.title_en`}></TextField>
        {/* <TextField source='description_th' label={`${CSR_FIELDS}.description_th`} sortable={false}></TextField> */}
        {/* <TextField source='description_en' label={`${CSR_FIELDS}.description_en`} sortable={false}></TextField> */}
        <TextField
          source='short_description_th'
          label={`${CSR_FIELDS}.short_description_th`}
          sortable={false}
        ></TextField>
        <TextField
          source='short_description_en'
          label={`${CSR_FIELDS}.short_description_en`}
          sortable={false}
        ></TextField>
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <DateField source='start_date' label={`${CSR_FIELDS}.start`} textAlign='center' />
        <DateField source='end_date' label={`${CSR_FIELDS}.end`} textAlign='center' />
        <BooleanField
          source='is_highlight'
          label={`${COMMON_FIELDS}.highlight.label`}
          textAlign='center'
          sortable={false}
        />
        {/* <BooleanField
          source='is_approved'
          label={`${COMMON_FIELDS}.approved.label`}
          textAlign='center'
          sortable={false}
        /> */}
        <BooleanField
          source='is_published'
          label={`${COMMON_FIELDS}.published.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default CSRList
